import type { ReactNode } from 'react'

import { Text } from '../Text'
import { cn } from 'utils/cn'

export type PhoneLayoutProps = {
  title: ReactNode
  children: ReactNode
  className?: string
  bodyClassName?: string
}

export function PhoneLayout({
  title,
  children,
  className,
  bodyClassName,
}: PhoneLayoutProps) {
  return (
    <div
      className={cn(
        'flex h-full max-h-full flex-col overflow-hidden',
        className,
      )}
    >
      <div className="flex-shrink-0 rounded-t-lg bg-primary p-4">
        <Text textColor="text-white" center bold>
          {title}
        </Text>
      </div>
      <div
        className={cn(
          'mb-[50px] min-h-0 flex-1 overflow-y-auto border border-t-0 border-neutral-200 bg-[#F9FAFB] p-4',
          bodyClassName,
        )}
      >
        {children}
      </div>
      <div className="mx-auto flex w-[300px] -translate-y-5 items-center justify-between">
        <div className="h-[25px] w-[25px] rounded-md bg-neutral-200" />
        <div className="h-[10px] w-[100px] rounded-md bg-neutral-200" />
        <div className="h-[25px] w-[25px] rounded-md bg-neutral-200" />
      </div>
    </div>
  )
}
